class CustomDropdown extends HTMLElement {
  constructor() {
    super();
    this.selectedEl = this.querySelector('.custom-dropdown__selected');
    this.optionsEl = this.querySelector('.custom-dropdown__options');
    this.selectEl = this.querySelector('select');
    this.init();
  }

  init() {
    this.addEventListeners();
  }

  addEventListeners() {
    // Toggle dropdown
    this.selectedEl.addEventListener('click', () => {
      this.toggle();
    });

    // Handle option selection
    this.optionsEl.querySelectorAll('.custom-dropdown__option:not([data-unavailable])').forEach((option) => {
      option.addEventListener('click', () => {
        const value = option.dataset.value;

        // Update select
        this.selectEl.value = value;
        this.selectEl.dispatchEvent(new Event('change', { bubbles: true }));

        // Update UI
        this.selectedEl.querySelector('.selected-text').textContent = option.querySelector('.option-text').textContent;

        this.optionsEl.querySelectorAll('.custom-dropdown__option').forEach((opt) => {
          opt.classList.toggle('selected', opt === option);
        });

        this.close();
      });
    });

    // Close when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.close();
      }
    });
  }

  toggle() {
    document.querySelectorAll('custom-dropdown').forEach((dropdown) => {
      if (dropdown !== this) {
        dropdown.classList.remove('active');
      }
    });
    this.classList.toggle('active');
  }

  close() {
    this.classList.remove('active');
  }
}

customElements.define('custom-dropdown', CustomDropdown);
